import { render, staticRenderFns } from "./loseReason.vue?vue&type=template&id=4b4f0242&lang=pug"
import script from "./loseReason.vue?vue&type=script&lang=js"
export * from "./loseReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports